import { FC, useContext, useEffect, useState } from "react";

import useFetch from "src/hooks/useFetch";
import { downloadPdfFile } from "src/helpers/downloadFile";
import { LoaderContext } from "src/context/loaderContext";

import { DownloadZipResponseType } from "src/pages/dashboard/types";
import { APIEndpoints } from "src/types/apiTypes";
import { CaseDetailAPIResponse, CaseDetailProps, StepperType } from "./types";
import { doesBenefitHasInOrOutNetwork } from "src/helpers/stats";


const StepperModal: FC<StepperType> = ({ onClick, caseId, drugName }): JSX.Element => {
  const { hideLoader, setLoader } = useContext(LoaderContext);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [activeTab, setActiveTab] = useState<string>('inNetwork');

  // Function to change the active tab
  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };
  const { data: caseDetails } =
    useFetch<CaseDetailAPIResponse>(APIEndpoints.CASE_DETAIL_POPUP, { case_id: caseId })



  const {
    loading: downloadCaseLoader, data: downloadCaseData, error: downloadCaseError, mutate: downloadRequestForm, removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadZipResponseType>(APIEndpoints.DOWNLOAD_REQUEST_FORM);

  useEffect(() => {
    if (downloadCaseData || downloadCaseError) {
      if (downloadCaseData && caseDetails) {
        const { response } = downloadCaseData;
        downloadPdfFile(response, `case_${caseId}_reports.pdf`);
      }
      hideLoader();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadCaseData, downloadCaseError]);

  const downloadRequestFileByCaseId = () => {
    if (downloadCaseData || downloadCaseError) clearRequestFileData();
    setLoader();

    downloadRequestForm({}, {}, { ref_id: caseId, type: `${drugName.toLowerCase().replace('°', '')}-request`, ref_type: 'Case', skip_pi: "true" });
  };

  const downloadInsuranceFileByCaseId = (insurance: CaseDetailProps) => {
    if (downloadCaseData || downloadCaseError) clearRequestFileData();
    setLoader();

    const benefit_type = doesBenefitHasInOrOutNetwork(insurance)
    downloadRequestForm({}, {}, { ref_id: insurance.insurance_id, type: `${drugName.toLowerCase().replace('°', '')}-investigation`, ref_type: 'Insurance' , skip_pi_investigation: "true", benefit_type });
  };



  return (
    <div className={`modal fade show show show-modal`} id="typeModal" aria-labelledby="typeModalLabel" aria-hidden="true" >
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="mb-0">Case {caseId} Details</h4>
            <button 
              disabled={downloadCaseLoader} 
              id="request-link" 
              className="btn btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 align-baseline text-start ms-3"
              onClick={downloadRequestFileByCaseId}
            >
              <i className="bi bi-file-pdf-fill"></i> Request
            </button>

            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClick}></button>
          </div>

          <div className="modal-body">
            <div className="alert alert-secondary bg-white py-1 mb-3">
              <div className="row">
                <div className="col-md-3">
                  <b>Dx Code(s):</b>
                </div>
               
                  {
                    <div className="col-md-9">{caseDetails && caseDetails.data &&
                      Array.isArray(caseDetails.data) && caseDetails.data.length > 0 && caseDetails.data[0].dx_code } </div>
                   
                    }
                  {/* <div className="col-md-3">
                  <b>Indication:</b>
                </div>
               
                  {
                    <div className="col-md-3">{caseDetails && caseDetails.data &&
                      Array.isArray(caseDetails.data) && caseDetails.data.length > 0 && caseDetails.data[0].indication } </div>
                   
                    }                 */}
              </div>
            </div>

            {caseDetails && caseDetails.data ?
              (Array.isArray(caseDetails.data) && caseDetails.data.length > 0 ?
                caseDetails.data.map((kase: CaseDetailProps) => (
                  <div className="bg-mist p-4 rounded-3 mb-3" key={kase.case_id}>
                      <div className="row">
                          <div className="col-12 col-md-8">
                              <div className="row">
                                  <div className="col-4">
                                      <span className="fw-semibold me-2">Insurance Name:</span>
                                  </div>
                                  <div className="col-8">
                                      <span className="fw-semibold me-2">{kase.insurance_name}</span>
                                  </div>
                              </div>
                          </div>
                          <div className="col-12 col-md-4">
                              <div className="text-end">
                                  <button
                                      className="btn btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 align-baseline text-start ms-3"
                                      disabled={downloadCaseLoader} onClick={() => downloadInsuranceFileByCaseId(kase)}
                                  >
                                      <i className="bi bi-file-pdf-fill"></i> Results
                                  </button>
                              </div>
                          </div>
                      </div>

                    <div className="card-body p-0">
                      {/* <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a className="nav-link" href="#">In Network</a>
                        </li>
                        <li className="nav-item">
                          <a className="nav-link" href="#">Out Network</a>
                        </li>

                      </ul> */}
                      {kase && kase.out_network_display ? (
                        <ul className="nav nav-tabs">
                          <li className="nav-item">
                            <a
                              className={`nav-link ${activeTab === 'inNetwork' ? 'active' : ''}`}
                              href="#inNetwork"
                              onClick={(e) => {
                                e.preventDefault();
                                handleTabClick('inNetwork');
                              }}
                            >
                              In Network
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className={`nav-link ${activeTab === 'outNetwork' ? 'active' : ''}`}
                              href="#outNetwork"
                              onClick={(e) => {
                                e.preventDefault();
                                handleTabClick('outNetwork');
                              }}
                            >
                              Out of Network
                            </a>
                          </li>
                        </ul>
                      ) : null}

                      {/* Tab Content */}
                      <div className="tab-content mt-3">
                        {/* In Network Content */}
                        <div  id="inNetwork" className={`tab-pane ${activeTab === 'inNetwork' ? 'show active' : ''}`}>
                            <div className="table-responsive">
                                <table className="table table-striped table-hover">
                                    <tbody>
                                    <tr>
                                        <td><b>Product Coverage:</b></td>
                                        <td>{kase.in_network_tab && kase.in_network_tab.product_coverage }</td>
                                        <td><b>Product Copay:</b></td>
                                        <td>{kase.in_network_tab && kase.in_network_tab.product_copay }</td>
                                    </tr>
                                    <tr>
                                        <td><b>Admin Coverage:</b></td>
                                        <td>{kase.in_network_tab && kase.in_network_tab.admin_coverage} </td>
                                        <td><b>Admin copay:</b></td>
                                        <td>{kase.in_network_tab && kase.in_network_tab.admin_copay }</td>
                                    </tr>
                                    <tr>
                                        <td><b>Office Coverage:</b></td>
                                        <td>{kase.in_network_tab && kase.in_network_tab.office_coverage}</td>
                                        <td><b>Office Copay:</b></td>
                                        <td>{kase.in_network_tab && kase.in_network_tab.office_copay }</td>
                                    </tr>
                                    <tr>
                                        <td><b>Deductible Met:</b></td>
                                        <td>{kase.in_network_tab && kase.in_network_tab.deductible_met }</td>
                                        <td><b>Deductible:</b></td>
                                        <td>{kase.in_network_tab && kase.in_network_tab.deductible}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Out of Pocket Met:</b></td>
                                        <td>{kase.in_network_tab && kase.in_network_tab.out_of_pocket_met }</td>
                                        <td><b>Out of Packet Max:</b></td>
                                        <td>{kase.in_network_tab && kase.in_network_tab.out_of_pocket_max }</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <b>Med Ben Notes: </b>
                                            {kase.in_network_tab && kase.in_network_tab.med_ben_notes }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <b>RX Ben Notes: </b>
                                            {caseDetails && caseDetails.data &&
                                                Array.isArray(caseDetails.data) && caseDetails.data.length > 0 && caseDetails.data[0].rx_ben_notes }
                                        </td>
                                    </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>


                        {/* Out of Network Content */}
                        <div id="outNetwork" className={`tab-pane ${activeTab === 'outNetwork' ? 'show active' : ''}`}>
                            <div className="table-responsive">
                                <table className="table table-striped table-hover">
                                    <tbody>
                                    <tr>
                                        <td><b>Product Coverage:</b></td>
                                        <td>{kase.out_network_tab &&  kase.out_network_tab.product_coverage}</td>
                                        <td><b>Product Copay:</b></td>
                                        <td>{kase.out_network_tab &&  kase.out_network_tab.product_copay}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Admin Coverage:</b></td>
                                        <td>{kase.out_network_tab &&  kase.out_network_tab.admin_coverage}</td>
                                        <td><b>Admin copay:</b></td>
                                        <td>{kase.out_network_tab &&  kase.out_network_tab.admin_copay}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Office Coverage:</b></td>
                                        <td>{kase.out_network_tab &&  kase.out_network_tab.office_coverage}</td>
                                        <td><b>Office Copay:</b></td>
                                        <td>{kase.out_network_tab &&  kase.out_network_tab.office_copay}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Deductible Met:</b></td>
                                        <td>{kase.out_network_tab &&  kase.out_network_tab.deductible_met}</td>
                                        <td><b>Deductible:</b></td>
                                        <td>{kase.out_network_tab &&  kase.out_network_tab.deductible}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Out of Pocket Met:</b></td>
                                        <td>{kase.out_network_tab &&  kase.out_network_tab.out_of_pocket_met}</td>
                                        <td><b>Out of Packet Max:</b></td>
                                        <td>{kase.out_network_tab &&  kase.out_network_tab.out_of_pocket_max}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <b>Med Ben Notes: </b>
                                            {kase.out_network_tab &&  kase.out_network_tab.med_ben_notes}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <b>RX Ben Notes: </b>
                                            {caseDetails && caseDetails.data &&
                                                Array.isArray(caseDetails.data) && caseDetails.data.length > 0 && caseDetails.data[0].rx_ben_notes }
                                        </td>
                                    </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                      </div>
                  </div>
                </div>
                ))
                : <h4 className="text-center fw-bold">{(caseDetails.data as string)}</h4>)
              : null
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepperModal;
